// extracted by mini-css-extract-plugin
export var container = "styles-module__container___U_brk";
export var successCheck = "styles-module__successCheck___stoxo";
export var ssrContainer = "styles-module__ssrContainer___uiSYB";